import { IDs } from '../../../helpers/IDs';

export function hasYearValues(data: any, standort: number, jahr: number): boolean {
    data = data || {};
    const kennzahlen: any = (data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort]
        || data[IDs.KENNZIFFERN_BERECHNET] || {};

    return !!(kennzahlen[jahr] || {}).co2_fussabdruck_total;
}
